// @flow
import type { Action } from '../actions/types';
import type { CartData } from '../actions/types';
import {
	INITIATE_FETCH_SKUS,
	FETCH_SKUS_SUCCESS,
	FETCH_SKUS_ERROR,
	SELECT_SKU,
	UPDATE_SKU_PURCHASE_COUNT,
	RESET_SKUS,
} from '../actions/types';

export type SkuState = {
	skus: Map<string, { [key: string]: any }>,
	fetching: boolean,
	error: any,
};

const initialState: SkuState = {
	skus: new Map(),
	fetching: false,
	error: null,
};

const processUpdatePurchaseCount = (cartData: CartData | null = null, state = {}): typeof initialState => {
	let { skus = new Map() } = state;
	if (!cartData || !Object.keys(skus)) {
		return state;
	}

	let updatedSkuData = {};
	const { key } = cartData.skuData;
	const sku = skus.get(key);
	if (sku) {
		updatedSkuData = { ...sku };
		if (cartData.action === 'ADD') {
			updatedSkuData.purchasedQty = updatedSkuData.purchasedQty ? updatedSkuData.purchasedQty + 1 : 1;
		} else {
			updatedSkuData.purchasedQty = updatedSkuData.purchasedQty ? updatedSkuData.purchasedQty - 1 : 0;
		}
		skus.set(key, updatedSkuData);
	}

	return {
		...state,
		skus: new Map(skus),
	};
};

export const skuReducer = (
	state: typeof initialState = initialState,
	{ type, payload }: Action
): typeof initialState => {
	switch (type) {
		case INITIATE_FETCH_SKUS:
			return {
				...state,
				fetching: true,
				skus: new Map(),
				error: null,
			};

		case FETCH_SKUS_SUCCESS:
			return {
				...state,
				fetching: false,
				skus: payload,
				error: null,
			};

		case FETCH_SKUS_ERROR:
			return {
				...state,
				fetching: false,
				skus: new Map(),
				error: payload,
			};

		case SELECT_SKU:
			return {
				...state,
				selectedSkus: payload,
			};

		case RESET_SKUS: {
			return {
				...state,
				fetching: false,
				skus: new Map(),
				error: null,
			};
		}

		case UPDATE_SKU_PURCHASE_COUNT:
			return processUpdatePurchaseCount(payload, state);

		default:
			return state;
	}
};
